import { render, staticRenderFns } from "./RemoveBackgroundModal.vue?vue&type=template&id=21dddc30&scoped=true"
import script from "./RemoveBackgroundModal.vue?vue&type=script&lang=js"
export * from "./RemoveBackgroundModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dddc30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21dddc30')) {
      api.createRecord('21dddc30', component.options)
    } else {
      api.reload('21dddc30', component.options)
    }
    module.hot.accept("./RemoveBackgroundModal.vue?vue&type=template&id=21dddc30&scoped=true", function () {
      api.rerender('21dddc30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser-product-selector/modals/RemoveBackgroundModal.vue"
export default component.exports